import React from 'react';
import { Link } from '@inertiajs/react';
import AuthLayout from '../../components/AuthLayout.jsx';

// Instructor "check your email" confirmation. Same wording as the reviewer
// version since the safety properties are identical (don't leak whether
// the address is registered).
export default function InstructorLoginLinkSent({ submitted_email }) {
  return (
    <AuthLayout>
      <div className="max-w-md mx-auto p-6 sm:p-8">
        <div className="bg-white border border-gray-200 rounded-2xl p-8 shadow-sm text-center">
          <div className="mx-auto w-12 h-12 bg-indigo-50 text-indigo-600 rounded-2xl flex items-center justify-center mb-3">
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
            </svg>
          </div>
          <h1 className="text-2xl font-bold text-gray-900">Check your email</h1>
          <p className="mt-3 text-sm text-gray-600">
            If <span className="font-medium text-gray-900">{submitted_email || 'that address'}</span>{' '}
            is registered as an instructor, we just sent a magic login link there.
          </p>
          <p className="mt-3 text-xs text-gray-500">
            The email comes from <span className="font-mono">donotreply@123ceu.com</span>.
            It may take a minute to arrive — check your spam folder if you don't see it.
          </p>
          <div className="mt-6">
            <Link
              href="/instructor/login"
              className="text-sm font-semibold text-indigo-600 hover:text-indigo-700"
            >
              Use a different email
            </Link>
          </div>
        </div>
      </div>
    </AuthLayout>
  );
}
